export default {
  AESKey: 'test',
};
